export default {
  AESKey: 'test',
};
